import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/ui/accordion.tsx");
